import { Qualification } from "./qualification";

export class EducationDetails {
  hasQualifications = '';
  qualifications: Qualification[] = [];
  completedEnglishTest = '';
  englishTestTaken = '';
  englishTestDate = '';
  englishAverageScore = '';
  englishReadingScore = '';
  englishWritingScore = '';
  englishSpeakingScore = '';
  englishListeningScore = '';
  isTranslator = '';
  translatorLanguage = '';
  skillsAssessment = '';
  assessingAuthority = '';
  assessedOccupation = '';
  assessmentDate = '';
}